import React from 'react';
import BannerWrap from "./style/grey";
import Container from "../../components/paper/container";
import SectionTitle from "../../components/heading/section";
import HomeSlogan2 from "../../components/heading/slogan2";
import P1 from "../../components/paragraph";

const Banner = () => {
    return (
        <BannerWrap style={{backgroundColor: '#f4e1ff'}}>
            <Container>
                {/* <P1></P1>
                <h4>Automate</h4> 
                <h1 style={{paddingTop: 10, paddingBottom: 0}}>Online Rental Application</h1>
                
                <SectionTitle>
                
                </SectionTitle>
                */}
                <HomeSlogan2>
                    The Only Vertically Integrated Pure Play End to End Property Management Platform
                </HomeSlogan2>               
            </Container>
        </BannerWrap>
    );
};

export default Banner;
